export default {
  notAvailableTextColor: '',
};
